import { DividerWithLabel } from '@payaca/ambrosia';
import { FC, Fragment } from 'react';

import PipelineGuardAndFieldset, {
  PipelineGuardAnd,
} from '@/ui/pages/pipelineConfigPage/components/guards/PipelineGuardAndFieldset';
import { PipelineGuardOrFormState } from '@/ui/pages/pipelineConfigPage/utils/pipelineGuardConversions';

type Props = {
  value: PipelineGuardOrFormState;
  onChange: (guard: PipelineGuardOrFormState | null) => void;
};

const PipelineGuardOrFieldset: FC<Props> = ({ value, onChange }) => {
  const handleAndGroupChange = (
    index: number,
    newAndGroup: PipelineGuardAnd | null
  ) => {
    if (newAndGroup === null) {
      // Remove this AND group
      const newChildren = value.children.filter((_, i) => i !== index);

      if (newChildren.length === 0) {
        // All AND groups removed, remove the entire guard
        onChange(null);
        return;
      }

      onChange({ ...value, children: newChildren });
      return;
    }

    const newChildren = [...value.children];
    newChildren[index] = newAndGroup;
    onChange({ ...value, children: newChildren });
  };

  return (
    <>
      {value.children.map((andGroup, index) => (
        <Fragment key={andGroup.tempIdentifier}>
          {index !== 0 && <DividerWithLabel label="or" />}
          <PipelineGuardAndFieldset
            value={andGroup}
            onChange={(newAndGroup) => handleAndGroupChange(index, newAndGroup)}
          />
        </Fragment>
      ))}
    </>
  );
};

export default PipelineGuardOrFieldset;
